import axios from 'axios';
import { API } from 'common/constants/api-urls';

/**
 * Fetches filter sets from the API.
 *
 * This function sends a GET request to the API endpoint for filter sets.
 * The response from the API is expected to be an object with a key 'items' that contains the filter sets.
 * @async
 * @function getFilterSets
 * @returns {Promise<AxiosResponse<any>>} The response from the API.
 */
export const getFilterSets = async () => await axios.get(API.FILTER_SET);

export const createFilterSet = async filterSet =>
  await axios.post(API.FILTER_SET, filterSet);

export const updateFilterSet = async (filterSetId, payload) =>
  await axios.put(`${API.FILTER_SET}/${filterSetId}`, payload);

export const deleteFilterSet = async filterSetId =>
  await axios.delete(`${API.FILTER_SET}/${filterSetId}`);
